import React from 'react';

const ManageOrders = () => {
    return (
        <div>
            <h3>Manage Orders</h3>
        </div>
    );
};

export default ManageOrders;